<template>
  <div class="relative overflow-hidden bg-white" :style="`padding-bottom: ${height / width * 100}%;`">
    <div class="absolute inset-0 bg-gray-400">
      <img :key="width" :src="src" loading="lazy" alt="Map" class="desktop w-full">
    </div>
  </div>
</template>

<script>
import { viewport } from '@placemarkio/geo-viewport'
import { useRuntimeConfig } from 'nuxt/app'
import venueTypes from '~/config/venue-types.json'
import { base64URLencode } from '~/utils/base64url'

export default {
  props: {
    width: { type: Number, default: 672 },
    height: { type: Number, default: 376 },
    destination: { type: Object, required: true },
    venues: { type: Array, required: true },
  },

  computed: {
    bounds () {
      return [
        Math.min(...this.venues.map(v => v.longitude)),
        Math.min(...this.venues.map(v => v.latitude)),
        Math.max(...this.venues.map(v => v.longitude)),
        Math.max(...this.venues.map(v => v.latitude)),
      ]
    },

    src () {
      const size = [this.width, this.height]
      const vp = viewport(this.bounds, size, {
        minzoom: undefined,
        maxzoom: undefined,
        tileSize: 512,
        allowFloat: true,
      })
      const markers = this.venues.map((v) => {
        let marker
        const venueType = venueTypes.find(vt => vt.id === v.venue_type_id)
        if (v.mainVenue) {
          marker = this.markerUrl()
        } else {
          marker = this.markerUrl(venueType && venueType.permalink)
        }
        return `icon:${marker}|${v.longitude},${v.latitude}|anchor:bottom`
      })

      let zoom = vp.zoom - (vp.zoom / 30)
      if (this.venues.length === 1) { zoom = 14 }

      const data = `${vp.center.join(',')},${zoom}/${size.join('x')}@2x.jpg?key=${useRuntimeConfig().public.mapKey}&markers=${markers.join('|')}`
      return `/static-map/${base64URLencode(data)}`
      // return `${useRuntimeConfig().public.mapStyle}/static/${data}`
      // return `https://api.mapbox.com/styles/v1/tripexpertweb/ckcdpjifn06ru1impw321xsqi/static/${markers.join(',')}/${vp.center.join(',')},${zoom}/${size.join('x')}@2x?access_token=${useRuntimeConfig().public.mapboxApiToken}`
    },
  },

  methods: {
    markerUrl (type = '') {
      if (type) { type = `-${type}` }
      return encodeURIComponent(`${useRuntimeConfig().public.appHost}/images/marker-fade.png`)
    },
  },
}
</script>

<style scoped lang="scss">
.map-image .isLoaded { @apply bg-white; }
</style>
